import { Fragment } from 'react';
import Link from 'next/link';
import styled from 'styled-components';

import { IBreadcrumb } from 'shared/types/Breadcrumbs';
import { variableFontRegular } from 'styles/theme/text';

export const SearchGridBreadcrumbs = ({ breadcrumbs }: { breadcrumbs: IBreadcrumb[] }) => {
  return breadcrumbs?.map((crumb, index) =>
    crumb?.isStatic ? (
      <Fragment key={crumb.name}>
        <SearchGridBreadcrumbs.Breadcrumb>
          {`${crumb.name}
            ${index !== breadcrumbs?.length - 1 ? ',' : ``}`}
        </SearchGridBreadcrumbs.Breadcrumb>
        &nbsp;
      </Fragment>
    ) : (
      <Fragment key={crumb.name}>
        <Link href={crumb.slug} passHref legacyBehavior>
          <SearchGridBreadcrumbs.BreadcrumbLink>{`${crumb.name}${
            index !== breadcrumbs?.length - 1 ? ',' : ``
          }`}</SearchGridBreadcrumbs.BreadcrumbLink>
        </Link>
        &nbsp;
      </Fragment>
    ),
  );
};

SearchGridBreadcrumbs.BreadcrumbLink = styled.a`
  ${variableFontRegular({ size: '11.5px', height: '14px' })}
  margin-bottom: 4px;
  padding-right: 3px;

  &:hover {
    text-decoration: underline;
  }

  text-decoration: underline;

  @media (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    text-decoration: none;
    padding-right: 0px;
  }
`;

SearchGridBreadcrumbs.Breadcrumb = styled.span`
  ${variableFontRegular({ size: '11.5px', height: '14px' })}
  margin-bottom: 4px;
  padding-right: 3px;

  @media (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    text-decoration: underline;
    padding-right: 0px;
  }
`;
